require('./index.css')
let mask = require('../mask/index')

$(window).scroll(function () {
    if ($(this).scrollTop() > 250) {
        $("#acMoive").attr('src', 'https://v.qq.com/iframe/player.html?vid=g00267mc70f&tiny=1&auto=1')
        $(this).unbind()
    }
})

let questionNum = 1;

let questFirst = {
    id:1,
    // num:'01',
    dry:'一、如果你外出旅游无意间发现了一个明星大八卦，你会怎么做？',
    anfirst:' A. 拍照发朋友圈',
    ansecond:' B. 拍照发微博',
    anthird:' C. 拍视频发抖音',
    anfour:' D. 拍下来放手机自己默默观赏'
};

let questSecond = {
    id:2,
    // num:'02',
    dry:'二、一个你默默暗恋多年的人，告诉你TA喜欢别人，你会怎么办？',
    anfirst:' A. 还是默默守护TA',
    ansecond:' B. 开始恨TA',
    anthird:' C. 重新换一个人喜欢',
    anfour:' D. 向TA告白再争取一下'
};

let questThird = {
    id:3,
    // num:'03',
    dry:'三、和好兄弟爱上同一个女人，你会怎么做？',
    anfirst:' A. 默默退出成全',
    ansecond:' B. 公平竞争',
    anthird:' C. 等待时机趁虚而入',
    anfour:' D. 转而喜欢自己兄弟'
};

let questFour = {
    id:4,
    // num:'04',
    dry:'四、如果你的钱多到20辈子也花不完，你会做什么事？',
    anfirst:' A. 每天享受至尊奢华的生活',
    ansecond:' B. 归隐山林做一个闲散人',
    anthird:' C. 为国家民族发展做贡献',
    anfour:' D. 在微博每天发10万红包吸粉'
};

let $answer = $("input[name=answerone]");  
let AQ = [];

// 上一题
$('.previous').click(function () {
    $answer.attr("checked",false);
    questionNum -- ;
    if (questionNum>=1) {
        getHtml(questionNum);
    } else {
        questionNum = 1;
    }
});

// 下一题
$('.next').click(function () {
    _qblog.wsd.click("GREATEXPECTATIONS.NEXTQUEST")
    zUtil.ensureLogin(function () {
        $answer.attr("checked",false);
        questionNum ++ ;
        if (questionNum<=4) {
            getHtml(questionNum);
        } else {
            questionNum =4 ;
        }
    })
});

// 取radio值
$('input').click(function(){
    AQ[questionNum-1] = $('input[name="answerone"]:checked').attr('value');
});

// 提交
$('.finish').click(function(){
    _qblog.wsd.click("ACT.GREATEXPECTATIONS.FINISH")
    
    if ( (AQ[0] === undefined) || (AQ[1] === undefined) || (AQ[2] === undefined) || (AQ[3] === undefined) ) {
        mask('answerEnd')
        return;
    }
    
    let answerArr = [0,0,0,0];
    for (let index = 0; index < 4; index++) {
        if (AQ[index] == 1) {
            answerArr[0] ++;
        } else if (AQ[index] == 2) {
            answerArr[1] ++;
        } else if (AQ[index] == 3) {
            answerArr[2] ++;
        } else if (AQ[index] == 4) {
            answerArr[3] ++;
        }
    }

    let answerNumId = getMaxId(answerArr);
    if (answerNumId == 0) {
        // 选A多
        mask('answerNum', '你在剧中的人物是：齐林（袁弘 饰）', '一看你就是务实，为人还忠厚老实的那种人</br>袁弘扮演的这个角色，你还满意吗？', 'http://stdl.qq.com/stdl/qb/kp/a.png')
    } else if (answerNumId == 1) {
        // 选B
        mask('answerNum', '你在剧中的人物是：林依依（佟丽娅 饰）', '一看你就爱憎分明！少侠有胆识，有见地，</br>佟丽娅都为你打call!', 'http://stdl.qq.com/stdl/qb/kp/b.png')
    } else if (answerNumId == 2) {
        // 选C
        mask('answerNum', '你在剧中的人物是于梦竹（郭采洁 饰）', '你是大大滴好人，心怀天下的富二代</br>郭采洁表示很赞赏你哦~', 'http://stdl.qq.com/stdl/qb/kp/c.png')
    } else {
        // 选D
        mask('answerNum', '你在剧中的人物是洪三元（陈思诚 饰）', '嘿，亲！你口味不是一般重啊~</br>连陈思诚都表示：你果然不是一般人！', 'http://stdl.qq.com/stdl/qb/kp/d.png')
    }
    // 提交后清空数值
    getHtml(1);
    $answer.removeAttr("checked");  
    questionNum = 1;
    AQ = [];
    answerArr = [0,0,0,0];
    answerNumId = 0;
});

// 取数组最大值的索引
function getMaxId(arr) {
    // 将数组第一个元素的值赋给max 
    let arrmax = arr[0];
    let arrnum = 0;
    // 使用for 循环从数组第一个值开始做遍历 
    for (var i = 1; i < arr.length; i++) {
        // 如果元素当前值大于max,就把这个当前值赋值给max 
        if (arr[i] > arrmax) {
            arrmax = arr[i];
            arrnum = i;
        }
    } 
    // 返回最大的值的索引
    return arrnum;
}

// 改变题目
function getHtml(num) {
    if (num == 1) {
        // $('.ranswer .spanNum').html('<span>'+ questFirst.num + '</span>')
        $('.rantitle .answerNum').html(questFirst.id)
        $('.questions .question-dry').html(questFirst.dry)
        $('.questions .one .an-one').html(questFirst.anfirst);
        $('.questions .two .an-two').html(questFirst.ansecond);
        $('.questions .three .an-three').html(questFirst.anthird);
        $('.questions .four .an-four').html(questFirst.anfour);
        $("input[value=" + AQ[num-1] + "]").attr('checked','true');
        $('.previous').css('display','none');
        $('.next').css('display','inline-block');
        $('.finish').css('display','none');
    } else if (num == 2) {
        // $('.ranswer .spanNum').html('<span>'+ questSecond.num + '</span>');
        $('.rantitle .answerNum').html(questSecond.id)
        $('.questions .question-dry').html(questSecond.dry)
        $('.questions .one .an-one').html(questSecond.anfirst);
        $('.questions .two .an-two').html(questSecond.ansecond);
        $('.questions .three .an-three').html(questSecond.anthird);
        $('.questions .four .an-four').html(questSecond.anfour);
        $("input[value=" + AQ[num-1] + "]").attr('checked','true');
        $('.previous').css('display','inline-block');
        $('.next').css('display','inline-block');
        $('.finish').css('display','none');
    } else if (num == 3) {
        // $('.ranswer .spanNum').html('<span>'+ questThird.num + '</span>');
        $('.rantitle .answerNum').html(questThird.id)
        $('.questions .question-dry').html(questThird.dry)
        $('.questions .one .an-one').html(questThird.anfirst);
        $('.questions .two .an-two').html(questThird.ansecond);
        $('.questions .three .an-three').html(questThird.anthird);
        $('.questions .four .an-four').html(questThird.anfour);
        $("input[value=" + AQ[num-1] + "]").attr('checked','true');
        $('.previous').css('display','inline-block');
        $('.next').css('display','inline-block');
        $('.finish').css('display','none');
    } else if (num == 4) {
        // $('.ranswer .spanNum').html('<span>'+ questFour.num + '</span>');
        $('.rantitle .answerNum').html(questFour.id)
        $('.questions .question-dry').html(questFour.dry)
        $('.questions .one .an-one').html(questFour.anfirst);
        $('.questions .two .an-two').html(questFour.ansecond);
        $('.questions .three .an-three').html(questFour.anthird);
        $('.questions .four .an-four').html(questFour.anfour);
        $("input[value=" + AQ[num-1] + "]").attr('checked','true');
        $('.next').css('display','none');
        $('.previous').css('display','inline-block');
        $('.finish').css('display','inline-block');
    }

}



// WEBPACK FOOTER //
// ./modules/video_info_answer/index.js